// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAppAttestKeyRegisterBody = {
  keyId: string;
  challengeId: string;
  attestationObject: string;
};

export type typeAppAttestKeyRegisterOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isRegistered: boolean };
};

export type typeAppAttestKeyRegisterOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAppAttestKeyRegisterOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAppAttestKeyRegisterBody = {
  type: "object",
  properties: {
    keyId: { type: "string", maxLength: 3000, minLength: 1 },
    challengeId: { type: "string", maxLength: 3000, minLength: 1 },
    attestationObject: { type: "string", maxLength: 20000, minLength: 1 },
  },
  required: ["keyId", "challengeId", "attestationObject"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAppAttestKeyRegister(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAppAttestKeyRegisterBody);
  }

  return async function postAppAttestKeyRegister(
    payload: typeAppAttestKeyRegisterBody,
  ): Promise<
    typeAppAttestKeyRegisterOutput200 | typeAppAttestKeyRegisterOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAppAttestKeyRegister" failed before calling the network. #7a968160f6d9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7a968160f6d9" },
        },
        data: null,
      } as typeAppAttestKeyRegisterOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/app-attest/key-register`,
      httpMethod: "POST",
      options,
    })) as
      typeAppAttestKeyRegisterOutput200 | typeAppAttestKeyRegisterOutput400;
  };
}
